import React, { useState } from "react";
import { Link } from "react-router-dom";

const Login = () =>{
    // const [hasTyped, setHasTyped] = useState(false);
    const uuid = generateUUID();
    // function handleChange(event) {
    //     const val = document.querySelector('input').value;
    //     if (val != "" && !val.includes(" ")) {
    //         setHasTyped(true)
    //         document.getElementById("error").innerHTML = "";
    //     } 
    //     else  {
    //         document.getElementById("error").innerHTML = "ID should not contain spaces or be empty"
    //         setHasTyped(false)
    //     }
    // }
    function addTurkId() {
        localStorage.setItem("user_id", uuid)
        console.log(uuid);
    }

    function generateUUID() { // Public Domain/MIT
        var d = new Date().getTime();//Timestamp
        var d2 = ((typeof performance !== 'undefined') && performance.now && (performance.now()*1000)) || 0;//Time in microseconds since page-load or 0 if unsupported
        return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
            var r = Math.random() * 16;//random number between 0 and 16
            if(d > 0){//Use timestamp until depleted
                r = (d + r)%16 | 0;
                d = Math.floor(d/16);
            } else {//Use microseconds since page-load if supported
                r = (d2 + r)%16 | 0;
                d2 = Math.floor(d2/16);
            }
            return (c === 'x' ? r : (r & 0x3 | 0x8)).toString(16);
        });
    }

    return (
        <section className="login">
         <div className="loginContainer">
             <label>Your ID has been generated below, click <b>Log In</b> below to proceed</label>
             {/* <input
             id="MTurk ID"
             type="text"
             autoFocus
             required
             onChange={handleChange}
             /> */}
             <label>{uuid}</label>
             <div className="btnContainer">
            {/* Removed from link: style={!hasTyped ? {pointerEvents: "none"} : null */}
                <Link to="home" 
                    className="link" 
                    >
                    <button type="button" 
                            className="bn" 
                            onClick={addTurkId} >
                                Log In
                    </button>
                </Link>
                {/* <p id="error" style={{color: "red"}}>ID should not contain spaces or be empty</p> */}
             </div>
         </div>
        </section>
    )
}
export default Login;